<!-- Begin Page Content -->
<div class="container-fluid">
    <!-- DataTales Example -->
    <div class="card shadow mb-4">
        <div class="card-body">
            <div class="table-responsive">
                <table datatable [dtOptions]="dtOptions" class="table table-bordered hover" width="100%"
                    cellspacing="0">
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>Username</th>
                            <th>Phone Number</th>
                            <th>Email</th>
                            <th>Added On</th>
                            <th>Referral Count</th>
                            <th>Status</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody *ngIf="ambassadors?.length != 0">
                        <tr *ngFor="let ambassador of ambassadors">
                            <td class="name">{{ (ambassador?.name !== '') ? ambassador.name : 'N/A' }}</td>
                            <td class="username">{{ (ambassador?.username !== '') ? ambassador.username : 'N/A'
                            }} </td>
                            <td class="phone_number">{{ (ambassador.phone_number !== '') ? ambassador.phone_number : 'N/A'
                                }} </td>
                            <td class="email">{{ (ambassador.email !== '') ? ambassador.email : 'N/A' }}</td>
                            <td>{{ ambassador.ambassadorEnabledOn }}</td>
                            <td>{{ ambassador.referralCount }}</td>
                            <td>{{ ambassador.isAmbassador ? 'Active' : 'Inactive' }}</td>
                            <td style="width: 15%;">
                                <a routerLink="/user/{{ ambassador._id }}" class="btn btn-primary btn-sm">View</a>
                            </td>
                        </tr>
                    </tbody>
                    <tbody *ngIf="ambassadors?.length == 0">
                        <tr class="text-center">
                            <td colspan="8" class="no-data-available">No records found!</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>

</div>
<!-- /.container-fluid -->